import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthorizationData } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IAuthorizeOpenIDCriteria {
  stateID: string;
  idToken: string;
}

export interface IAuthorizeOpenIDOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (body: IAuthorizeOpenIDCriteria, opts: IAuthorizeOpenIDOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["openid", "authorize"]);
  const { stateID, idToken } = body;

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(uri)) : false,
  });

  let localRequestOpts: RequestInit = {
    body: JSON.stringify({ stateID, idToken }),
    headers,
    method: "POST",
    mode: "cors",
  };

  if (!apiKey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function authorizeOpenID(
  body: IAuthorizeOpenIDCriteria,
  opts: IAuthorizeOpenIDOpts,
): Promise<JsonQuery<IResultstash<IAuthorizationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthorizationData>>(createRequest(body, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default authorizeOpenID;
